import { useStyleMode } from '@/features/restaurant/useStyleMode';

interface Props {
  qty: number;
  min?: number;
  max?: number;
  size?: 'sm' | 'md';
  onChange: (qty: number) => void;
}

const SIZE_CLASSES = {
  sm: {
    wrap: 'gap-2',
    btn: 'w-10 h-10 border-2 text-lg',
    qty: 'font-mono font-bold text-base min-w-[2ch] text-center',
  },
  md: {
    wrap: 'gap-3',
    btn: 'w-[58px] h-[60px] border-[3px] text-2xl',
    qty: 'font-mono font-bold text-xl min-w-[2ch] text-center',
  },
} as const;

export default function QtyStepper({ qty, min = 1, max = 99, size = 'md', onChange }: Props) {
  const dec = () => onChange(Math.max(min, qty - 1));
  const inc = () => onChange(Math.min(max, qty + 1));
  const s = SIZE_CLASSES[size];
  // Opera premium swaps the thick stamp border + sharp corners for a hairline.
  const premium = useStyleMode() === 'premium';
  const shape = premium ? '!border rounded-[8px]' : 'rounded-none';
  return (
    <div className={`flex items-center ${s.wrap}`}>
      <button
        type="button"
        onClick={dec}
        disabled={qty <= min}
        data-fx-mute
        className={`${s.btn} ${shape} border-ink bg-paper text-ink font-display disabled:opacity-40`}
        aria-label="diminuer"
      >−</button>
      <span className={s.qty}>{qty}</span>
      <button
        type="button"
        onClick={inc}
        disabled={qty >= max}
        data-fx-mute
        className={`${s.btn} ${shape} border-ink bg-mint text-[var(--on-primary)] font-display disabled:opacity-40`}
        aria-label="augmenter"
      >+</button>
    </div>
  );
}
